import {
  type Assign,
  Field as ArkField,
  PolymorphicProps,
} from "@ark-ui/react";
import { HTMLStyledProps } from "@zenchef/styled-system/jsx";
import {
  aromaField,
  AromaFieldVariantProps,
} from "@zenchef/styled-system/recipes";
import { slots } from "../../theme/recipes/field";
import { createStyleContext, Slot } from "../../utils/createStyleContext";

const { withProvider, withContext } = createStyleContext(aromaField);

export interface FieldRootProps
  extends Assign<HTMLStyledProps<"div">, PolymorphicProps>,
    AromaFieldVariantProps {}

export type ToastSlots = Slot<typeof aromaField>;

export const slotsMaps: Record<ToastSlots, ToastSlots> = slots.reduce(
  (acc, slot) => ({ ...acc, [slot]: slot }),
  {} as Record<ToastSlots, ToastSlots>,
);

export const FieldRoot = withProvider<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, ArkField.RootProps & AromaFieldVariantProps>
>(ArkField.Root, slotsMaps.root);

export const FieldHelper = withContext<
  HTMLSpanElement,
  Assign<
    HTMLStyledProps<"span">,
    ArkField.HelperTextProps & AromaFieldVariantProps
  >
>(ArkField.HelperText, slotsMaps.hintText);
